// src/pages/AdminPage/components/AdminTopbar.tsx
import { Menu, RefreshCw } from "lucide-react";
import type { AdminTab } from "../utils/adminTypes";

const tabTitles: Record<AdminTab, string> = {
  dashboard: "Dashboard",
  users: "Foydalanuvchilar",
  questions: "Savollar",
  topics: "Mavzular",
  notifications: "Bildirishnomalar",
  videos: "Videolar",
  reports: "Shikoyatlar",
};

interface AdminTopbarProps {
  tab: AdminTab;
  onMobileMenuOpen: () => void;
  onRefresh: () => void;
}

export default function AdminTopbar({
  tab,
  onMobileMenuOpen,
  onRefresh,
}: AdminTopbarProps) {
  return (
    <div
      className="admin-topbar"
      style={{
        background: "#0D1526",
        borderBottom: "1px solid #1E2D45",
        padding: "14px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 40,
        flexWrap: "wrap",
        gap: 10,
      }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button
          className="hamburger"
          onClick={onMobileMenuOpen}
          style={{
            background: "transparent",
            border: "1px solid #1E2D45",
            borderRadius: 10,
            color: "#64748B",
            cursor: "pointer",
            padding: 8,
            display: "flex",
          }}>
          <Menu size={18} />
        </button>
        <div>
          <h1
            style={{ color: "#fff", fontWeight: 800, fontSize: 18, margin: 0 }}>
            {tabTitles[tab]}
          </h1>
          <p style={{ color: "#475569", fontSize: 12, margin: 0 }}>
            AvtoMind boshqaruv paneli
          </p>
        </div>
      </div>
      <button
        onClick={onRefresh}
        className="btn-hover"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "8px 14px",
          borderRadius: 10,
          border: "1px solid #1E2D45",
          background: "transparent",
          color: "#64748B",
          cursor: "pointer",
          fontSize: 13,
        }}>
        <RefreshCw size={14} /> Yangilash
      </button>
    </div>
  );
}
